































































































































































































import {
    Vue,
    Component,
} from "@/shared/vuepack";
import { useThemeStore } from "@/shared/store/theme";

@Component({
    components: {
    }
})
export default class PartnerUserBulkAddModal extends Vue {
    themeStore = useThemeStore();
}
